import { PERMISSIONS } from '../components/Permissions/utils/permissions.js';
import { userService } from './user.service.js';

export const utilsService = {
    handleResponse,
    getHomePagePath,
    handleResponseBlob
};

function handleResponse(response) {
  return response.text().then(text => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = { message: text };
    }
    
    if (!response.ok) {
      switch(response.status){
        case 400:
          const error = new Error(data.message || text || "Errore nella richiesta");
          console.error("handle Error",error);
          break;
        case 401:
           // auto logout if 401 response returned from api
          userService.logout();
          window.location.reload(true);
          break;
        case 409:
          const conflictError = new Error(data.message || text || "Risorsa già esistente");
          conflictError.statusCode = 409;
          conflictError.data = data;
          return Promise.reject(conflictError);
        case 404:
          return Promise.resolve(data)
        default:
      }
      
      const error = (data && data.message) || text || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function getHomePagePath(props, user = null) {
  
  if(user === null)
    return "/logout";

  let pathHomepage = "/"

  const storagedUser = JSON.parse(user);

  if(!storagedUser.authorities.includes(PERMISSIONS.SYSTEM_ALL)) {

    if(storagedUser.authorities.includes(PERMISSIONS.NEGOTIATION_ALL)) {
      pathHomepage = "/sales/negotiations"
    } else if(storagedUser.authorities.includes(PERMISSIONS.PLANNING_ALL)) {
      pathHomepage = "/delivery/plannings"
    } else if(storagedUser.authorities.includes(PERMISSIONS.CAMPAIGN_ALL)) {
      pathHomepage = "/delivery/campaigns"
    }

  }

  let { from } = props.location.state || {
    from: { pathname: pathHomepage },
  };

  return from
}

function handleResponseBlob(response) {
  return response.blob().then(blob => {
      if(blob?.type.includes("image")) {
        return blob;
      } else {
        return null
      }
    }
  );
}